<!-- =========================================================================================
    File Name: ResetPassword.vue
    Description: Reset Password Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
    <div class="h-screen flex w-full bg-img">
        <div class="vx-col sm:w-3/5 md:w-3/5 lg:w-3/4 xl:w-3/5 mx-auto self-center">
            <vx-card>
                <div slot="no-body" class="full-page-bg-color">
                    <div class="vx-row">
                        <div class="vx-col hidden sm:hidden md:hidden lg:block lg:w-1/2 mx-auto self-center">
                            <img src="@/assets/images/pages/reset-password.png" alt="login" class="mx-auto">
                        </div>
                        <div class="vx-col sm:w-full md:w-full lg:w-1/2 mx-auto self-center  d-theme-dark-bg">
                            <div class="p-8">
                                <div class="vx-card__title mb-8">
                                    <h4 class="mb-4">Repor senha</h4>
                                    <p>Por favor, introduza a sua nova senha.</p>
                                </div>
                                <!-- <vs-input type="email" label-placeholder="Email" v-model="value1" class="w-full mb-6" /> -->
                                <vs-input type="password" label-placeholder="Nova senha" v-model="value2" class="w-full mb-6"  v-validate="'required|min:4|max:10'" ref="senha" name="senha"/>
                                 <span class="text-danger text-sm" v-show="errors.has('senha')">{{ errors.first('senha') }}</span>
                                <vs-input type="password" label-placeholder="Confirme a senha" v-model="password" class="w-full mb-8" v-validate="'required|min:4|max:10|confirmed:senha'" data-vv-as="confirmação" name="confirmação"/>
                                <span class="text-danger text-sm" v-show="errors.has('confirmação')">{{ errors.first('confirmação') }}</span>

                                <div class="flex flex-wrap justify-between flex-col-reverse sm:flex-row">
                                    <vs-button type="border" to="/pages/login" class="w-full sm:w-auto mb-8 sm:mb-auto mt-3 sm:mt-auto">Voltar para login</vs-button>
                                    <vs-button class="w-full sm:w-auto" @click="reset">Repor</vs-button>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </vx-card>
        </div>
    </div>
</template>

<script>
import http from '../../../http-common';
export default {
    data() {
        return {
            err:'',
            value3: '',
            password:'',
        }
    },

     methods:{
        
        async reset () {
            this.$validator.validateAll().then(result => {
        if (result) {
               this.$vs.loading()
      
      let data = {
        password:this.password,
        passwordToken:this.$route.query.token,
      };
      http
        .post('/auth/change-password', data)
        .then((success) => {
          success;
         
            this.$vs.loading.close()
          this.$router.push({ name: 'page-login' })
          
        })
        .catch((error) => {
          error;
           this.$vs.loading.close()
          if(error.response.status==401 ){
         this.err=error.response.data
            this.$vs.notify({
            title: 'Erro',
            text: this.err,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger',
            position: "top-center",
          })
          }else{
 this.$vs.loading.close()
         this.$vs.notify({
            title: 'Erro',
            text: this.err,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger',
            position: "top-center",
          })
          }
         
        });
        }})
      
    },
    }
}
</script>
